import React, { useState, useMemo } from 'react'

const GlobalContext = React.createContext()
export function GlobalProvider (props) {
  const [barraActiva, setBarraActiva] = useState(false)

  const value = useMemo(() => {
    return { barraActiva, setBarraActiva }
    //eslint-disable-next-line
  }, [barraActiva, setBarraActiva])

  return <GlobalContext.Provider value={value} {...props} />
}
export function useGlobal () {
  const context = React.useContext(GlobalContext)
  if (!context) {
    throw new Error('No se encontro Usuario en el contexto')
  }
  return context
}
